import {
  buildScalePattern,
  noteToSemitones,
  SCALE_INTERVALS,
  type NoteName,
} from "./guitarEngine";
import { pianoHandForMidi } from "./pianoPedagogy";
import type { PracticeNoteEvent } from "./practiceNoteModel";

function buildScaleEventsForRange(
  root: NoteName,
  scaleType: string,
  startOctave: number,
  octaveCount: number
): PracticeNoteEvent[] {
  const pattern = buildScalePattern(root, scaleType);
  const intervals = SCALE_INTERVALS[scaleType] ?? SCALE_INTERVALS.major;
  const events: PracticeNoteEvent[] = [];

  for (let oct = 0; oct < octaveCount; oct++) {
    const rootMidi = noteToSemitones(root) + (startOctave + oct + 1) * 12;
    pattern.notes.forEach((note, i) => {
      const midi = rootMidi + (intervals[i] ?? 0);
      events.push({
        midi,
        start: events.length,
        duration: 1,
        hand: pianoHandForMidi(midi),
        degree: pattern.degrees[i] ?? "?",
        step: note,
      });
    });
  }

  return events;
}

/** Notas de escala en una octava para pentagrama de teclado (clave de sol). */
export function buildScaleTrebleEvents(
  root: NoteName,
  scaleType: string,
  startOctave = 4
): PracticeNoteEvent[] {
  return buildScaleEventsForRange(root, scaleType, startOctave, 1);
}

/**
 * Gran pentagrama: cada clave muestra una octava completa desde la tónica (grado I),
 * no un corte por registro que dejaba el sol empezando en el VII.
 */
export function buildScaleGrandStaffEvents(
  root: NoteName,
  scaleType: string
): { treble: PracticeNoteEvent[]; bass: PracticeNoteEvent[] } {
  return {
    treble: buildScaleEventsForRange(root, scaleType, 4, 1),
    bass: buildScaleEventsForRange(root, scaleType, 2, 1),
  };
}
